import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { t } from 'i18next';

import FetchModule from '../../../../Model/Network/FetchModule';
import { getStoredOrDeviceAppLanguage } from '../../../../Language/i18n';
import TermsModal from '../Model/TermsModal';
import DataColumnBox from '../../../Unit/Model/DataColumnBox';

export default function AgreementPage() {

  const navigate = useNavigate();
  const params = useParams();

  const [data, setData] = useState([
    {
      termsId: 0,
      termsTitle: '',
      termsText: '',
      termsTitleEn: '',
      termsTextEn: '',
      isEssential: true,
      isClicked: false
    }]);
  const [organizerId, setOrganizerId] = useState(0);
  const [isAllAgree, setIsAllAgree] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);

  const [isClicked, setIsClicked] = useState(false);
  const [language, setLanguage] = useState(getStoredOrDeviceAppLanguage());

  // 페이지 이름 변경내역 업로드 //
  useEffect(() => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ pageName: t('동의하기'), isAvailableGoback: false }));
    }
    catch (e) {
      console.log("Web Message Post Error : " + e);
    }
  }, []);

  // Message Detect Save And Delete //
  useEffect(() => {
    // Android //
    document.addEventListener('message', handleMassage);

    // IOS //
    window.addEventListener('message', handleMassage);

    return () => {
      // Android //
      document.removeEventListener('message', handleMassage);

      // IOS //
      window.removeEventListener('message', handleMassage);
    }
  }, [])

  // 약관 API Call //
  useEffect(() => {
    let organizerId = parseInt(params.organizerId);

    setOrganizerId(organizerId);

    let requestData = {
      organizerId: organizerId
    }
    
    const fetchModule = new FetchModule();
    (
      async () => {
        let language = getStoredOrDeviceAppLanguage();
        
        setLanguage(language);

        const responseData = await fetchModule.postDataOfEventVer2('terms/' + organizerId, 'POST');
        
        if (responseData.status === 200) {
          console.log(responseData.data);
          setData([responseData.data]);
				}
      }
    )();
  }, [organizerId])

  // 전체 동의여부 확인 //
  useEffect(() => {
    for(let i = 0; i < data.length; i++) {
      if (data[i].isEssential && !data[i].isClicked) {
        setIsAllAgree(false);
        return;
      }
    }

    setIsAllAgree(true);
  }, [data])

  // React Native에서 웹으로 보내는 데이터 handler //
  function handleMassage(e) {
    let responseData = JSON.parse(e.data);

    if (responseData.goBack) navigate(-1);
  }

  // 전체 동의 클릭 //
  function onClickAllAgree() {
    let newData = data.slice();

    for (let i = 0; i < newData.length; i++) {
      newData[i].isClicked = !newData[i].isClicked;
    }
    
    if (organizerId === 37) setIsClicked(newData[0].isClicked);

    setData(newData);
  }
  
  // 동의 버튼 클릭 //
  function onClickAgree(index) {
    let newData = data.slice();

    newData[index].isClicked = !newData[index].isClicked;
    setData(newData);
  }

  // 이용약관 보기 클릭 //
  function onClickTermsViewButton() {
    // console.log('이용약관 보기')
    setIsViewModal(true);
  }

  // 참가 신청 바로가기 클릭 //
  function onClickGoNext() {
    if (!isAllAgree) return;
    else if (organizerId === 37 && !isClicked) return;

    navigate('/select/v2/' + organizerId);
  }
  
  return (
    <TopLevelWrapper>
      { isViewModal && <TermsModal data={data[0]} language={language} closeFn={() => setIsViewModal(false)}/> }
      <ComponentWrapper>
        <TitleWrapper style={{ marginTop: `22px`}}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#4F4F4F'>{t('약관에 동의해 주세요.')}</Text>
        </TitleWrapper>
        <AllAgreeBox onClick={onClickAllAgree}>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#4F4F4F'>{t('약관 전체 동의')}</Text>
          </TitleWrapper>
        </AllAgreeBox>
        <TitleWrapper style={{ marginTop: `47px`}}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#4F4F4F'>{t('참가 신청 약관')}</Text>
        </TitleWrapper>
        {
          data.map((data, index) => (
            <AgreeBox key={index}>
              <CheckBox isClicked={data.isClicked} onClick={() => onClickAgree(index)}/>
              <TextWrapper onClick={() => onClickAgree(index)}>
                <Text style={{ minWidth: t('[필수]') === '[필수]' ? '41px' : '46px', marginRight: `4px` }} fontFamily='NotoSansKR-Medium' fontSize={16} color={data.isEssential ? '#5BD98A' : '#FF8B48'}>{data.isEssential ? t('[필수]') : t('[선택]')}</Text>
                <Text fontFamily='NotoSansKR-Medium' fontSize={16} color='#4F4F4F'>{language === 'Korea' ? data.termsTitle : data.termsTitleEn}</Text>
              </TextWrapper>
              <ViewButton onClick={onClickTermsViewButton}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={16} color='#5BD98A'>{t('보기')}</Text>
              </ViewButton>
            </AgreeBox>
          ))
        }
        {
          organizerId === 37 &&
          <AgreeBox style={{ justifyContent: 'flex-start', gap: '4px' }} onClick={() => setIsClicked(!isClicked)} >
            <CheckBox isClicked={isClicked}/>
            <TextWrapper style={{ width: '90%' }}>
              <Text style={{ minWidth: '41px', marginRight: `4px` }} fontFamily='NotoSansKR-Medium' fontSize={16} color='#5BD98A'>[필수]</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={16} color='#4F4F4F'>디비전 별 참가 제한에 부분을 확인하셨나요</Text>
            </TextWrapper>
          </AgreeBox>
        }
        {
          organizerId === 37 &&
          <Wrapper style={{ marginTop: `12px`}}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>만약 부정 참가 적발 시 오프라인 참가 제외와 참가비 환불이 불가능합니다</Text>
          </Wrapper>
        }
      </ComponentWrapper>
      <GoNextButton isClicked={isAllAgree && (isClicked || organizerId !== 37)} onClick={onClickGoNext}>
        <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#FFFFFF'>{t('참가 신청 바로가기')}</Text>
      </GoNextButton>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  // height: 100%;
  height: 100vh;

  background-color: #FFFFFF;
`;

const ComponentWrapper = styled.div`
display: flex;
flex-direction: column;

justify-content: center;
align-items: center;

width: 100%;
`;

const TitleWrapper = styled.div`
display: flex;
flex-direction: row;
// flex-wrap: wrap;

justify-content: flex-start;
align-items: flex-start;

width: 90.33%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;

  justify-content: flex-start;
  align-items: flex-start;

  width: 90.33%;
`;

const CareWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 4px;
  
  min-width: 36px;
  min-height: 20px;
`;

const AllAgreeBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 90.33%;
  height: 49px;

  margin-top: 16px;

  border: 1px solid #E0E0E0;
  border-radius: 8px;
  background-color: #FFFFFF;

  :hover {
    cursor: pointer;
    // background-color: #E0E0E0;
  }

  transition: all 0.3s ease-in-out;
`;

const AgreeBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 90.33%;

  margin-top: 16px;
`;

const CheckBox = styled.div`
  width: 20px;
  height: 20px;

  margin-top: 4px;

  border: 1px solid #E0E0E0;
  border-radius: 5px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#FFFFFF`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 79.94%;
`;

const ViewButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

const GoNextButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-bottom: 34px;

  // width: 90.33%;
  width: 100%;
  // height: 60px;
  height: 75px;

  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#E0E0E0`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  padding: 0 0 0 0;
  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }
`;
